// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/172.26.59.72+4873+css-loader@6.7.3_webpack@5.76.3/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/172.26.59.72+4873+css-loader@6.7.3_webpack@5.76.3/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".bay-layout-fullscreen{position:fixed;top:0;left:0;bottom:0;right:0;background-color:var(--wk-color-white);z-index:100}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___.toString();
